import React, { useEffect, useRef, useState } from 'react';
import styles from '../styles/ScrollPath.module.css';

const ScrollPath = () => {
  const pathRef = useRef(null);
  const [pathLength, setPathLength] = useState(0);

  useEffect(() => {
    if (pathRef.current) {
      const length = pathRef.current.getTotalLength();
      setPathLength(length);
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (!pathRef.current || pathLength === 0) return;
      
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPercent = scrollTop / docHeight;
      
      // Draw the path based on scroll position
      const drawLength = pathLength * scrollPercent;
      pathRef.current.style.strokeDashoffset = pathLength - drawLength;
    };

    // Initial setup
    if (pathRef.current && pathLength > 0) {
      pathRef.current.style.strokeDasharray = pathLength;
      pathRef.current.style.strokeDashoffset = pathLength;
    }

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial call

    return () => window.removeEventListener('scroll', handleScroll);
  }, [pathLength]);

  return (
    <div className={styles.scrollPath}>
      <svg
        className={styles.scrollPath__svg}
        viewBox="0 0 100 2000"
        preserveAspectRatio="none"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Background path (faint) */}
        <path
          className={styles.scrollPath__bg}
          d="M 50 0 
             Q 20 200, 50 400 
             Q 80 600, 50 800 
             Q 20 1000, 50 1200 
             Q 80 1400, 50 1600 
             Q 20 1800, 50 2000"
        />
        {/* Animated path (accent color) */}
        <path
          ref={pathRef}
          className={styles.scrollPath__line}
          d="M 50 0 
             Q 20 200, 50 400 
             Q 80 600, 50 800 
             Q 20 1000, 50 1200 
             Q 80 1400, 50 1600 
             Q 20 1800, 50 2000"
        />
      </svg>
    </div>
  );
};

export default ScrollPath;
